import * as React from "react";
import type { SVGProps } from "react";
const SvgForkAndKnive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 21c0 .55.45 1 1 1s1-.45 1-1V2.99a1.002 1.002 0 0 0-1.71-.7C14 6.59 14 11.85 14 15c0 .55.45 1 1 1h3zm0-7h-2c.04-2.27.27-5.33 2-8.14z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M7 21c0 .55.45 1 1 1s1-.45 1-1V10.87c1.72-.44 3-2.01 3-3.87V3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 1.1-.9 2-2 2s-2-.9-2-2V3c0-.55-.45-1-1-1s-1 .45-1 1v4c0 1.86 1.28 3.43 3 3.87z"
    />
    <path
      fill="currentColor"
      d="M7 7c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1z"
    />
  </svg>
);
export default SvgForkAndKnive;
